const { createReducer } = require('../helpers')

const {
  GET_CERTIFICATE_INFO,
  GET_CERTIFICATE_INFO_SUCCESS,
  GET_CERTIFICATE_INFO_ERROR,
  GET_CERTIFICATE_INFO_RESET,
} = require('./constants')

const initialState = {
  getCertificateInfo: {
    data: null,
    loading: false,
    error: null,
  },
}

module.exports = createReducer({
  [GET_CERTIFICATE_INFO]: draft => ({
    getCertificateInfo: {
      ...draft.getCertificateInfo,
      data: null,
      loading: true,
      error: null,
    },
  }),
  [GET_CERTIFICATE_INFO_SUCCESS]: (draft, action) => ({
    getCertificateInfo: {
      ...draft.getCertificateInfo,
      loading: false,
      data: action.payload.data,
    },
  }),
  [GET_CERTIFICATE_INFO_ERROR]: (draft, action) => ({
    getCertificateInfo: {
      ...draft.getCertificateInfo,
      loading: false,
      error: action.payload.error,
    },
  }),
  [GET_CERTIFICATE_INFO_RESET]: () => ({
    getCertificateInfo: { ...initialState.getCertificateInfo },
  }),

}, initialState)
